import { render, staticRenderFns } from "./EditShiftType.vue?vue&type=template&id=0d34172c&"
import script from "./EditShiftType.vue?vue&type=script&lang=ts&"
export * from "./EditShiftType.vue?vue&type=script&lang=ts&"
import style0 from "./EditShiftType.vue?vue&type=style&index=0&id=0d34172c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports